import { getOpenClass, getClassStudents } from '@/api/hozoor'
export default {
    state: {
        classes: [],
        students: [],

    },

    mutations: {

        SET_OPEN_CLASSES: (state, data) => {
            state.classes = [...data]
        },
        SET_CLASS_STUDENTS: (state, data) => {
            state.students = data
        }

    },

    actions: {
        getOpenClass({ commit }) {

            return new Promise((resolve, reject) => {
                getOpenClass().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_OPEN_CLASSES', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getClassStudents({ commit }, payload) {

            commit('SET_CLASS_STUDENTS', [])
            return new Promise((resolve, reject) => {
                getClassStudents(payload.classID, payload.tarikh).then(response => {
                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_CLASS_STUDENTS', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },


    }
}